import { render, staticRenderFns } from "./CustomerLogHistory.vue?vue&type=template&id=8e1cd4c8&scoped=true&"
import script from "./CustomerLogHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerLogHistory.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLogHistory.vue?vue&type=style&index=0&id=8e1cd4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1cd4c8",
  null
  
)

export default component.exports